import React from 'react';
import FormattedText from '../../../components/01_atoms/FormattedText';
import PropTypes from 'prop-types';
import Webform from '../../../components/03_organisms/Webform';
import Form from '../../Form';

import styles from './index.module.scss';

const BBContactUs = ({ webform, text, isRecaptchaEnabled, nonce }) => {
  return (
    <div className={`bb ${styles['bb-contact-us']}`}>
      <div className="container">
        <div className={styles['bb-contact-us__container']}>
          {text && <FormattedText text={text} className={styles['bb-contact-us__text']} />}
          <div className={styles['bb-contact-us__form']}>
            <Form>
              <Webform webform={webform} isRecaptchaEnabled={isRecaptchaEnabled} nonce={nonce} />
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

BBContactUs.propTypes = {
  text: PropTypes.string.isRequired,
  webform: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        field_id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      }),
    ).isRequired,
    successType: PropTypes.oneOf(['redirect', 'message']).isRequired,
    successMessage: PropTypes.string.isRequired,
    successUrl: PropTypes.string.isRequired,
  }).isRequired,
  isRecaptchaEnabled: PropTypes.bool.isRequired,
  nonce: PropTypes.string.isRequired,
};

export default BBContactUs;
